import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import * as Bixby from '$/core';
import { createDealNote, getDealNotes } from '$/store/portfolio/actions';
import { AddNote } from '../add-note';
import { AppState } from '$/store';
import Loading from '$/components/loading/Loading';
import './index.scss';
import { DealNote } from '$/core/models';

interface IDealNotesProps {
  isLoadingDealNotes: boolean;
  currentCompany: Bixby.Models.Company;
  dealNotes?: Bixby.Models.DealNote[];
  dispatchCreateDealNote: (clientCompanyId: string, note: string) => Promise<void>;
  dispatchGetDealNotes: (clientCompanyId: string) => Promise<void>;
}

const DealNotes: React.FC<IDealNotesProps> = props => {
  const { isLoadingDealNotes, currentCompany, dealNotes, dispatchCreateDealNote, dispatchGetDealNotes } = props;
  const [isCreatingDealNote, setIsCreatingDealNote] = useState(false);

  useEffect(() => {
    if (currentCompany.clientCompanyId) {
      dispatchGetDealNotes(currentCompany.clientCompanyId);
    }
  }, [currentCompany.clientCompanyId, dispatchGetDealNotes]);

  const handleAddModal = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    setIsCreatingDealNote(true);
  };

  const handleModalDismiss = () => {
    setIsCreatingDealNote(false);
  };

  const handleSubmit = (id: string, note: string) => {
    dispatchCreateDealNote(id, note);
    setIsCreatingDealNote(false);
  };

  const tableRows = Bixby.Utils.orderBy(dealNotes || [], c => c.createdDate, 'desc').map((row, index) => {
    const rowTyped = row as DealNote;
    return (
      <tr key={index}>
        <td>
          <div className="deal_notes_entry">
            <p className="note_byline">
              {rowTyped.createdBy} ({Bixby.Utils.formatByLineDateTime(rowTyped.createdDate)}):
            </p>
            {rowTyped.note}
          </div>
        </td>
      </tr>
    );
  });

  return currentCompany.clientCompanyId ? (
    <React.Fragment>
      <div className="deal_notes_wrap">
        <table className="table deal_notes_table">
          <thead>
            <tr className="deal_notes_header">
              <th>Deal Notes ({currentCompany.clientName})</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <button type="button" className="add_btn" onClick={handleAddModal}>
                  + Add Note
                </button>
                <AddNote
                  active={isCreatingDealNote}
                  clientCompanyId={currentCompany.clientCompanyId}
                  onAddSubmit={handleSubmit}
                  onCloseModal={handleModalDismiss}
                  title="Add New Deal Note"
                />
              </td>
            </tr>
            {isLoadingDealNotes && (
              <tr className="loading">
                <td>
                  <Loading inline />
                </td>
              </tr>
            )}
            {!isLoadingDealNotes && tableRows}
          </tbody>
        </table>
      </div>
    </React.Fragment>
  ) : null;
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoadingDealNotes: state.portfolioState.isLoadingDealNotes,
    dealNotes: state.portfolioState.dealNotes,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchCreateDealNote: (clientCompanyId: string, note: string) => dispatch(createDealNote(clientCompanyId, note)),
  dispatchGetDealNotes: (clientCompanyId: string) => dispatch(getDealNotes(clientCompanyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DealNotes);
